export const linkopingLight = {
  name: 'linkoping:light',
  extends: 'citizen2:light',
  cssPath: 'custom/styles/lin/linkoping-light.theme.scss',
  vuetify: {
    defaults: {
      HWorkspace: {
        HBulletin: {
          HActionLink: {
            HScopedBulletinActionBtn: {
              color: 'surface',
            },
          },
        },
      },

      HBulletin: {
        HActionLink: {
          HScopedBulletinActionBtn: {
            size: 'default',
            rounded: 'pill',
            flat: true,
            icon: false,
            appendIcon: 'mdi:mdi-chevron-right',
            variant: 'text',
            color: 'surface',
          },
        },
      },

      VCard: {
        rounded: 'sm',
        color: 'primary',
      },

      VBtn: {
        rounded: null,
      },

      HItemCard: {
        VCard: {
          color: 'surface',
        },
      },
    },
    theme: {
      dark: false,
      colors: {
        primary: '#00829b',
        secondary: '#ffb549',
        toolbar: '#00829b',
        'on-start-page': '#333333',
        bulletin: '#00829b',
        'on-bulletin': '#ffffff',
        surface: '#ffffff',
        'surface-variant': '#f5f5f5',
        'workspace-bulletin': '#00829b',
        'on-workspace-bulletin': '#ffffff',
        'badge-primary': '#ffb549',
        'badge-secondary': '#ffb549',
        'badge-tertiary': '#ffb549',
        'bulletin-board': '#eaeaea',
        'on-bulletin-board': '#333333',

        foretag: '#f5f5f5',
        fastigheter: '#f5f5f5',

        // Page header background colors
        'page-companies-header-bg': '#f5f5f5',
        'on-page-companies-header-bg': '#333333',
        'page-properties-header-bg': '#f5f5f5',
        'on-page-properties-header-bg': '#333333',
        'page-authorizations-header-bg': '#f5f5f5',
        'on-page-authorizations-header-bg': '#333333',
        'page-children-header-bg': '#f5f5f5',
        'on-page-children-header-bg': '#333333',
        'page-enrollments-header-bg': '#f5f5f5',
        'on-page-enrollments-header-bg': '#333333',
        'page-employments-header-bg': '#f5f5f5',
        'on-page-employments-header-bg': '#333333',
        'page-eservices-header-bg': '#f5f5f5',
        'on-page-eservices-header-bg': '#333333',
        'page-cases-header-bg': '#f5f5f5',
        'on-page-cases-header-bg': '#333333',

        // Item card border colors
        'card-company': '#f5f5f5',
        'card-property': '#f5f5f5',
        'card-authorization': '#f5f5f5',
        'card-child': '#f5f5f5',
        'card-enrollment': '#f5f5f5',
        'card-employment': '#f5f5f5',
        'card-case': '#f5f5f5',
        'card-association': '#8C8C8C',
      },
    },
  },
};
